import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonIconSmComponent } from '@new-core/components/buttons-game/button-icon-sm/button-icon-sm.component';
import { ColorfilledInputComponent } from '@new-core/components/inputs-gi/colorfilled-input/colorfilled-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from '@shared/components/checkbox/checkbox.module';
import { AbacusModule, FormFieldModule } from '@shared/components/games';
import { MenarAbacusToolComponent } from './menar-abacus-tool.component';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatOption, MatSelect, MatSelectTrigger } from '@angular/material/select';

@NgModule({
  declarations: [MenarAbacusToolComponent],
  exports: [MenarAbacusToolComponent],
  imports: [
    CommonModule,
    AbacusModule,
    FormsModule,
    FormFieldModule,
    TranslateModule,
    ButtonIconSmComponent,
    ColorfilledInputComponent,
    CheckboxModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatSelectTrigger,
  ],
})
export class MenarAbacusToolModule {}
